import { QuickstartCard } from './QuickstartCard';
import { QuickstartTheme, isGameReleased, getWishlistButtonImage } from '../types/theme';

interface QuickstartActionPageProps {
  theme: QuickstartTheme;
  headerText?: string[]; // Optional array of header text lines (e.g., ["SNEAK PEEK", "IS AT CAPACITY"])
  onButtonClick: () => void;
}

/**
 * Shared component for CTA and Error pages
 * Both pages have the same structure: logo, optional header text, game logo, release date, button
 */
export const QuickstartActionPage = ({ theme, headerText, onButtonClick }: QuickstartActionPageProps) => {
  return (
    <div
      className='flex min-h-screen items-center justify-center overflow-auto p-4'
      style={{
        backgroundImage: theme.pageBackgroundImage ? `url(${theme.pageBackgroundImage})` : undefined,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <QuickstartCard theme={theme} showHeader={false} hideFooter={true}>
        <div className='flex flex-col items-center text-center'>
          {/* Studio Logo */}
          {theme.studioLogo && <img src={theme.studioLogo} alt={theme.studioName} className='mt-4 h-16' />}

          {/* Optional header text (e.g., "SNEAK PEEK", "IS AT CAPACITY") */}
          {headerText && headerText.length > 0 && (
            <div className='mt-8'>
              {headerText.map((text, index) => (
                <div key={index} className='font-["Inter"] text-2xl font-semibold' style={{ color: '#FEF3C7' }}>
                  {text}
                </div>
              ))}
            </div>
          )}

          {/* Game Logo */}
          {theme.gameLogo && <img src={theme.gameLogo} alt={theme.gameName} className={headerText ? 'mt-8 h-20' : 'mt-12 h-20'} />}

          {/* Release Date - only show for unreleased games */}
          {theme.releaseDate && !isGameReleased(theme) && (
            <div className='mt-6 font-["Inter"] text-2xl font-semibold' style={{ color: theme.releaseDateTextColor || theme.primaryColor }}>
              <div>COMING:</div>
              <div>{theme.releaseDate}</div>
            </div>
          )}

          {/* Wishlist/Store Button */}
          {theme.steamUrl && (() => {
            const buttonImage = getWishlistButtonImage(theme);
            return (
              <img
                src={buttonImage.src}
                alt={buttonImage.alt}
                onClick={onButtonClick}
                className={`${isGameReleased(theme) ? 'mt-8' : 'mt-3'} cursor-pointer hover:opacity-90`}
                style={{ height: '64px' }}
              />
            );
          })()}

          {/* Powered by Playcast */}
          <img src='/quickstart/pbp.png' alt='Powered by Playcast' className='mb-4 mt-12 h-6' />
        </div>
      </QuickstartCard>
    </div>
  );
};

